/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RightDto
 */
export interface RightDto {
    /**
     * Right ID
     * @type {string}
     * @memberof RightDto
     */
    id: string;
    /**
     * Right name
     * @type {string}
     * @memberof RightDto
     */
    name: string;
    /**
     * Right description
     * @type {string}
     * @memberof RightDto
     */
    description: string;
}

/**
 * Check if a given object implements the RightDto interface.
 */
export function instanceOfRightDto(value: object): value is RightDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function RightDtoFromJSON(json: any): RightDto {
    return RightDtoFromJSONTyped(json, false);
}

export function RightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function RightDtoToJSON(json: any): RightDto {
    return RightDtoToJSONTyped(json, false);
}

export function RightDtoToJSONTyped(value?: RightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

